/* istanbul ignore file */

export const FORM_BUILDER_FORMAT_OPTIONS_CONSTANTS = {
    DATE: 'date',
    NUMBER: 'number',
    DATE_FORMAT: 'MM/DD/YYYY',
    DATE_SAVE_FORMAT: 'YYYY-MM-DD'
};

export const FORM_BUILDER_OPTIONS_TOOLTIP_MESSAGES_CONSTANTS = {
    DATE_FORMATTING_DISABLED: 'This formula outputs a date, so number formatting is not available.',
    DURATION_FORMATTING_DISABLED: 'This formula outputs a duration (days), so number formatting is not available.'
};
